import styled from 'styled-components';

const TransparentBackgroundContainerAtom = styled.div`
  background-color: transparent;
  width: 100%;
`;

export default TransparentBackgroundContainerAtom;
